import { render, staticRenderFns } from "./CmgOrderConfirmationCancelOrderFailureModal.vue?vue&type=template&id=82c55ba8&scoped=true&lang=pug"
import script from "./cmg-order-confirmation-cancel-order-failure-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-order-confirmation-cancel-order-failure-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgOrderConfirmationCancelOrderFailureModal.vue?vue&type=style&index=0&id=82c55ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c55ba8",
  null
  
)

export default component.exports